import { StyleSheet } from "react-native";
import { FlickOColors } from "./color";
import { getResponsiveSize } from "./globalStyles";
import { commonStyles } from "./commonStyles";

export const homeStyles = StyleSheet.create({
  locationHeader: {
    padding: getResponsiveSize(16),
    backgroundColor: FlickOColors.white,
    borderBottomWidth: 1,
    borderBottomColor: FlickOColors.gray.light,
  },
  locationTitle: {
    fontSize: getResponsiveSize(18),
    fontWeight: "600",
    color: FlickOColors.text.primary,
    marginBottom: getResponsiveSize(4),
  },
  locationSubtitle: {
    fontSize: getResponsiveSize(14),
    color: FlickOColors.text.secondary,
  },
  container: {
    flex: 1,
    backgroundColor: FlickOColors.gray.lighter,
  },
  topBar: {
    backgroundColor: FlickOColors.white,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: getResponsiveSize(16),
    borderBottomWidth: 1,
    borderBottomColor: FlickOColors.gray.light,
  },
  statusButton: {
    flexDirection: "row",
    alignItems: "center",
    gap: getResponsiveSize(8),
    paddingVertical: getResponsiveSize(8),
    paddingHorizontal: getResponsiveSize(16),
    borderRadius: 20,
    backgroundColor: FlickOColors.green,
  },
  statusButtonOffline: {
    backgroundColor: FlickOColors.red,
  },

  offlineButton: {
    backgroundColor: FlickOColors.error + "10",
  },
  statusText: {
    fontSize: getResponsiveSize(14),
    fontWeight: "500",
  },
  tabsContainer: {
    flexDirection: "row",
    padding: getResponsiveSize(8),
    gap: getResponsiveSize(6),
    flexWrap: "wrap",
    width: "100%",
    justifyContent: "space-between",
  },
  tab: {
    ...commonStyles.shadowStyle,
    width: "31%",
    justifyContent: "center",
    flexDirection: "row",
    alignItems: "center",
    padding: getResponsiveSize(12),
    borderRadius: 8,
    backgroundColor: FlickOColors.gray.lighter,
    gap: getResponsiveSize(4),
  },
  activeTab: {
    ...commonStyles.shadowStyleDark,
    backgroundColor: FlickOColors.primary,
  },
  tabText: {
    fontSize: getResponsiveSize(14),
    color: FlickOColors.text.primary,
  },
  activeTabText: {
    color: FlickOColors.white,
  },
  tabCount: {
    fontSize: getResponsiveSize(14),
    color: FlickOColors.text.secondary,
  },
  activeTabCount: {
    color: FlickOColors.white,
  },
  title: {
    fontSize: getResponsiveSize(24),
    fontWeight: "600",
    padding: getResponsiveSize(16),
  },
});
